import React from "react";
import Layout from "../../components/Login/Layout";
import LoginScreen from "../../components/Login/LoginScreen";
import ForgotPassword from "../../components/Login/ForgotPassword";
import ResetPassword from "../../components/Login/ResetPassword";

// Pre-auth screens. No lazyLoad: these have no hydration fetch and bootstrap
// already nests them under its own "/" outlet and appends the 404 fallback.
export default [
  {
    element: <Layout />,
    children: [
      { path: "login", element: <LoginScreen /> },
      { path: "forgot-password", element: <ForgotPassword /> },
      { path: "reset-password", element: <ResetPassword /> },
    ],
  },
];
